export default {
    product: {
        onStock: {
            label: "Skladem"
        },
        outOfStock: {
            label: "Obvykle do 5 týdnů",
            tooltip: "Tento výrobek objednáváme ze skladu našeho dodavatele, kde by měl být k dispozici. Dodání očekávejte předběžně do 5 týdnů od potvrzení objednávky. Tento termín může být v závislosti na aktuální dostupnosti u dodavatele prodloužen bez nároku na kompenzaci."
        },
        priceIsNotFinal: {
            label: "Cena může být upřesněna",
            tooltip: "Tato cena může být upřesněna v potvrzení objednávky, které vám zašleme. Pokud se cena bude lišit, máte právo zboží z objednávky kdykoli bezplatně odebrat."
        },
        priceOnRequest: {
            label: "Cena na vyžádání",
            tooltip: "Nejedná se o standardní výrobek, a proto vám cenu ověříme u výrobce po zaslání objednávky. Pokud s cenou nebudete souhlasit, máte právo objednávku zrušit."
        },
        catalogNumber: "Kód zboží:",
        cntVariants: "Počet variant",
        displayVariants: "Zobrazit varianty",
        addToBasket: "Do košíku"
    },
    basket: {
        content: "Obsah košíku",
        goToBasket: "Přejít do košíku",
        wizard: {
            overview: {
                headline: "Košík",
                totalPrice: "Celková cena:",
                shipping: "Poštovné a balné",
                empty: {
                    message: "Momentálně nemáte v košíku žádné zboží.",
                    addByCatalogNumber: "Přidat zboží podle katalogového čísla"
                },
                continueWithShopping: "Pokračovat v nákupu",
                continueWithOrder: "Pokračovat v objednávce",
                requestPriceOffer: "Chci nezávaznou cenovou nabídku"
            },
            contact: {
                orderHeadline: "Košík / Dokončení objednávky",
                priceOfferHeadline: "Košík / Žádost o cenovou nabídku",
                contactInfo: "Kontaktní údaje",
                email: "E-mail",
                phone: "Telefon",
                firstname: "Jméno",
                lastname: "Příjmení",
                street: "Ulice a č.p.",
                city: "Město",
                zipCode: "PSČ",
                country: "Země",
                billingInfo: "Fakturační údaje",
                withWatOnly: "(*Dodáváme pouze zákazníkům s IČO)",
                company: "Název firmy",
                regId: "IČO",
                flagVatId: "Jsem plátce DPH",
                vatId: "DIČ",
                flagDeliveryInfo: "Chci doručit na jinou adresu",
                shippingInfo: "Dodací adresa",
                completeOnlyInfo: "Volba kompletnosti",
                completeOnlyYes: "Chci zaslat pouze kompletní zásilku.",
                completeOnlyNo: "Chci zaslat zboží, které je k dodání do 2 týdnů, na ostatní počkám.",
                orderNote: "Poznámka k objednávce",
                priceOfferNote: "Poznámka k cenové nabídce",

                flagOrderNote: "Chci zadat poznámku k objednávce",
                flagPriceOfferNote: "Chci zadat poznámku k cenové nabídce",

                finishOrderInfo: "Dokončení objednávky",
                finishPriceOfferInfo: "Dokončení žádosti o cenovou nabídku",
                flagNewsletter: "Přeji si dostávat informace o novinkách a akčních nabídkách",
                back: "Zpět",
                submitOrder: "Dokončit objednávku",
                submitPriceOffer: "Odeslat žádost o cenovou nabídku",
                checkboxOrderPrefix: "Seznámil jsem se s",
                checkboxOrderTerms: "obchodními podmínkami",
                checkboxOrderAnd: "a podmínkami o",
                checkboxOrderPrivacy: "zpracování osobních údajů",
                checkboxPriceOfferAgreePolicy: "Odesláním žádosti o cenovou nabídku potvrzuji, že jsem se seznámil s podmínkami",
                privacyPolicyLink: "zpracování osobních údajů",
               validation: {
                    requiredField: "Pole je povinné",
                    invalidEmail: "E-mail není platný",
                    selectOption: "Vyberte jednu z možností",
                    regId: "Dodáváme pouze zákazníkům s IČO"
                }
            },
            findByCatalogNumber: {
                label: "Přidat zboží:",
                placeholder: "kód zboží z katalogu"
            },
            orderFailed: {
                headline: "Jejda...",
                message1: "Při zpracování objednávky došlo k chybě číslo:",
                message2: "Prosím kontaktujte naši podporu.",
                tryAgain: "Zkusit znovu"
            },
            orderProcessing: {
                headline: "Zpracování",
                message: "Vaše požadavka se zpracovává..."
            }
        }
    },
    search: {
        placeholder: "Hledaný výraz ...",
        results: {
            headline: "Hledaný výraz:",
            noResults: "Litujeme, vašim kritériím neodpovídá žádný výsledek.",
            contactLink: "Zeptat se přes Kontaktní formulář",
            categories: "Kategorie",
            products: "Produkty",
            pages: "Stránky",
            totalProducts: "produktů celkem"
        }
    }
};
